"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./resourceEditPage.scss");

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _reactRouter = require("react-router");

var _typesafeActions = require("typesafe-actions");

var _ResourceEditor = _interopRequireDefault(require("../../../components/resources/editors/ResourceEditor"));

var _article = require("../../../redux/article/article.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _topic = require("../../../redux/topics/topic.types");

var _api = require("../../../redux/api/api.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ResourceEditPage extends _react.default.Component {
  constructor(props) {
    super(props);

    this.saveArticle = (article, close) => {
      this.props.saveArticle(article);
      this.setState({
        shouldCloseOnSave: close
      });
    };

    this.state = {
      shouldCloseOnSave: false
    };
  }

  componentDidMount() {
    const {
      loadResourceTopics,
      getRequestedArticle,
      requestedArticleId
    } = this.props;
    loadResourceTopics();

    if (requestedArticleId && requestedArticleId != -1) {
      getRequestedArticle();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      saveArticleStatus,
      requestedArticleId,
      newArticleId,
      clearLoadStatus,
      studyId,
      history,
      updateNewArticleId
    } = this.props;

    if (!prevProps.saveArticleStatus.isSuccess && saveArticleStatus.isSuccess) {
      // Need to reset the state.ui.articles.newArticleId to -1 after each save
      updateNewArticleId(-1); // If "Save and Close" button is clicked, we skip all navigation logic and navigation back

      if (this.state.shouldCloseOnSave) {
        this.props.history.goBack();
        return;
      } // If we're not editing an existing (non-new) article, navigate to the edit screen for the new article.


      if (requestedArticleId == -1 && newArticleId != -1) {
        clearLoadStatus((0, _typesafeActions.getType)(_article.saveArticleAsync.success)); // Upon successful NEW article creation, navigate to the edit page for said article

        history.push(`/study/${studyId}/resources/edit/${newArticleId}`);
      }
    }
  }

  render() {
    const {
      resourceTopics,
      article,
      loadResourceTopicsStatus,
      getRequestedEditResourceStatus
    } = this.props; // TODO change all of this to allow creating a new article or have a separate ResourceNewPage.

    if (loadResourceTopicsStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading Topics");
    }

    if (getRequestedEditResourceStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading Article");
    }

    if (loadResourceTopicsStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error loading topics:", loadResourceTopicsStatus.errorMessage);
    }

    if (getRequestedEditResourceStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error loading article: ", getRequestedEditResourceStatus.errorMessage);
    }

    if (!resourceTopics) {
      return /*#__PURE__*/_react.default.createElement("div", null, "The topics did not load properly. No error message was returned from the server.");
    }

    if (resourceTopics.length <= 0) {
      return /*#__PURE__*/_react.default.createElement("div", null, "No topics were loaded. You need to create topics first, so that articles can be categorized appropriately.");
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      id: "hmp-resource-edit-page"
    }, /*#__PURE__*/_react.default.createElement(_ResourceEditor.default, {
      resourceTopics: resourceTopics,
      originalArticle: article,
      saveArticle: this.saveArticle
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  resourceTopics: selectors.getResourceTopicsCascader,
  article: selectors.getRequestedEditResource,
  loadResourceTopicsStatus: selectors.loadResourceTopicsStatus,
  getRequestedEditResourceStatus: selectors.getRequestedEditResourceStatus,
  saveArticleStatus: selectors.saveArticleStatus,
  requestedArticleId: selectors.getRequestedEditResourceId,
  newArticleId: selectors.selectNewArticleId
});

const mapDispatchToProps = dispatch => {
  return {
    loadResourceTopics: () => dispatch(_topic.loadResourceTopicsAsync.request()),
    getRequestedArticle: () => dispatch(_article.getRequestedArticleAsync.request()),
    saveArticle: article => dispatch(_article.saveArticleAsync.request(article)),
    clearLoadStatus: type => dispatch((0, _api.clearStatus)(type)),
    updateNewArticleId: id => dispatch((0, _article.updateNewArticleId)(id))
  };
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceEditPage));

exports.default = _default;